var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_b_69_995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 6.23107C38.4705 6.23107 47.7692 15.5298 47.7692 27.0003C47.7692 38.4708 38.4705 47.7695 26.9999 47.7695C15.5294 47.7695 6.23071 38.4708 6.23071 27.0003C6.23071 15.5298 15.5294 6.23107 26.9999 6.23107Z",
    stroke: "white",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 6.23107C38.4705 6.23107 47.7692 15.5298 47.7692 27.0003C47.7692 38.4708 38.4705 47.7695 26.9999 47.7695C15.5294 47.7695 6.23071 38.4708 6.23071 27.0003C6.23071 15.5298 15.5294 6.23107 26.9999 6.23107Z",
    fill: "white",
    fillOpacity: 0.1,
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1791 25.0838C28.425 25.0838 29.435 26.0938 29.435 27.3397C29.435 28.5857 28.425 29.5957 27.1791 29.5957C25.9331 29.5957 24.9231 28.5857 24.9231 27.3397C24.9231 26.0938 25.9331 25.0838 27.1791 25.0838Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_69_995",
    x: -14.7693,
    y: -14.7695,
    width: 83.5386,
    height: 83.5391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_69_995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_69_995",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotpoint);
export default __webpack_public_path__ + "static/media/hotpoint.bec41d79c90833481b7ea51c2e9c4fbe.svg";
export { ForwardRef as ReactComponent };